<main id="mainContent" class="appbased-tv">
  <rch-header></rch-header>
  <div  class="appbased-tv__body">
    <router-outlet></router-outlet>
  </div>
  <rch-footer></rch-footer>
</main>

